import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../components/Layout";
import { Search, Download } from "lucide-react";
import "./../../styles/member/historyuser.css";
import { TransactionsService, TransactionDto } from "../../services/transactionsService";
import { formatDateTimeWithSeconds } from "../../utils/dateFormatter";
const viStatus: Record<string, string> = {
  pending: 'Đang chờ',
  completed: 'Hoàn thành',
  failed: 'Thất bại',
  cancelled: 'Đã hủy',
};

const HistoryUser: React.FC = () => {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState<TransactionDto[]>([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await TransactionsService.listMine({ page, limit, status: 'completed' });
        setRows(res.data);
        setTotal(res.total);
      } catch (e: any) {
        // Handle error silently
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [page, limit]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((t) =>
      t.transactionCode?.toLowerCase().includes(q) ||
      t.type?.toLowerCase().includes(q) ||
      String(t.amount).toLowerCase().includes(q) ||
      t.status?.toLowerCase().includes(q)
    );
  }, [rows, search]);

  return (
    <Layout>
      <div className="historyuser-page">
        {/* ===== HEADER ===== */}
        <div className="historyuser-title">
          <h2>Lịch sử giao dịch</h2>
          <p>Hoá đơn mà bạn đã thanh toán</p>
        </div>

        {/* ===== FILTER BAR ===== */}
        <div className="historyuser-filter">
          <div className="filter-search">
            <Search size={18} className="search-icon" />
            <input
              type="text"
              placeholder="Tìm kiếm..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <button className="export-btn">
            <Download size={18} />
            <span>Xuất file</span>
          </button>
        </div>

        {/* ===== TABLE ===== */}
        <div className="historyuser-table">
          <table>
            <thead>
              <tr>
                <th>Mã giao dịch</th>
                <th>Loại</th>
                <th>Số tiền</th>
                <th>Trạng thái</th>
                <th>Thời gian</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={5}>Đang tải...</td></tr>
              )}
              {!loading && filtered.length === 0 && (
                <tr><td colSpan={5}>Không có giao dịch</td></tr>
              )}
              {!loading && filtered.map((t) => (
                <tr key={t.id}>
                  <td>{t.transactionCode}</td>
                  <td>{t.type}</td>
                  <td>{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(t.amount)}</td>
                  <td>
                    {(() => {
                      const statusClass = t.status === 'completed' ? 'active' : t.status === 'failed' ? 'locked' : 'pending';
                      const label = viStatus[t.status] || t.status;
                      return <span className={`status ${statusClass}`}>{label}</span>;
                    })()}
                  </td>
                  <td>{formatDateTimeWithSeconds(t.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Trang trước</button>
          <span>Trang {page}</span>
          <button disabled={page * limit >= total} onClick={() => setPage((p) => p + 1)}>Trang sau</button>
        </div>
      </div>
    </Layout>
  );
};

export default HistoryUser;
